module.exports = __webpack_public_path__ + "static/media/СЗФО_2013.b7c14613.png";